<template>
  <dv-border-box-10>
    <div class="main">
      <div class="main-header">
        <h3>项目概览</h3>
      </div>
      <div class="contentbox">
        <div class="contentbox-item contentbox-top">
          <div class="top-item">{{projectInfo.invest}}万元<br />工程造价</div>
          <div class="top-item">{{projectInfo.buildingArea}}㎡<br />建筑面积</div>
          <div class="top-item">{{projectInfo.memberCount}}人<br />项目总人数</div>
        </div>
        <div class="contentbox-item contentbox-middle">
          <span style="text-align:center;display:flex;flex-direction:row;justify-content: space-around;"
            ><span>开始时间:{{projectInfo.startDate}}</span><span>竣工时间:{{projectInfo.startDate}}</span></span
          ><span
            style="display:flex;flex-direction:row;justify-content: center;margin-top:2%"
            >进度:<el-progress
              :stroke-width="22"
              :percentage="projectInfo.schedule"
              style="width:70%;margin-left:3%;margin-top:1%"
            ></el-progress
          ></span>
        </div>
        <div class="contentbox-item contentbox-footer">
          <span>项目地址: {{projectInfo.address}}</span>
        </div>
      </div>
    </div>
    <!-- 2022.1.6日前版本 -->
    <!-- <div class="main">
      <div class="main-header">
        <h3>人员出勤率</h3>
      </div>
      <div class="contentbox">
        <div id="attendancerate" style="width:85%;height:100%"></div>
        <div class="rightbox">
          <div class="item"
            ><i class="iconfont ali-icon-guanlirenyuan1"></i
            >&nbsp;<span class="icontext">管理人员:</span
            ><span class="itemtext">199</span></div
          >
          <div class="item"
            ><i class="iconfont ali-icon-laowurenyuan"></i
            >&nbsp;<span class="icontext">劳务人员:</span
            ><span class="itemtext">299</span></div
          >
        </div>
      </div>
    </div> -->
  </dv-border-box-10>
</template>
<style scoped>
.main {
  width: 100%;
  height: 100%;
  color: #fff;
  position: relative;
  background: rgba(47, 79, 79, 0.1);
  padding-top: 2%;
}
.main-header {
  margin-left: 2%;
}
.main-header h3 {
  font-size: 30px;
}
.contentbox {
  width: 100%;
  height: 85%;
  font-size: 25px;
}
.contentbox-item {
  width: 100%;
  height: 33%;
}
.contentbox-top {
  display: flex;
  flex-direction: row;
}
.contentbox-middle {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}
.contentbox-footer {
  display: flex;
  justify-content: flex-start;
  padding-top:8%;
  padding-left:8%
}
.top-item {
  width: 33%;
  height: 100%;
  text-align: center;
  padding-top: 4%;
}
>>>.el-progress__text {
    color: white;
}
/* 2022.1.6日前版本 */
/* .main {
  width: 100%;
  height: 100%;
  color: #fff;
  position: relative;
  background: rgba(47, 79, 79, 0.1);
  padding-top: 2%;
}
.main-header {
  margin-left: 2%;
}
.main-header h3 {
  font-size: 40px;
}
.contentbox {
  width: 80%;
  height: 85%;
  display: flex;
  flex-direction: row;
}
.item {
  text-align: center;
  display: inline-block;
  width: 100%;
}
.rightbox {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content:center
}
.iconfont{
  font-size:50px
}
.icontext {
  font-size: 20px;
}
.itemtext {
  font-size: 20px;
} */
</style>
<script>
// 2022.1.6日前版本
// import * as echarts from "echarts/core";
// import { GaugeChart } from "echarts/charts";
// import { CanvasRenderer } from "echarts/renderers";
// echarts.use([GaugeChart, CanvasRenderer]);
export default {
  props:{
    projectInfo:Object
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // 2022.1.6日前版本
    // var myChart = echarts.init(document.getElementById("attendancerate"));
    // var that = this;
    // const gaugeData = [
    //   {
    //     value: 90,
    //     name: "出勤率",
    //     title: {
    //       offsetCenter: ["0%", "-20%"],
    //       color: "#fff",
    //       fontSize: "20",
    //     },
    //     detail: {
    //       valueAnimation: true,
    //       offsetCenter: ["0%", "10%"],
    //     },
    //   },
    // ];
    // var option = {
    //   series: [
    //     {
    //       type: "gauge",
    //       startAngle: 90,
    //       endAngle: -270,
    //       pointer: {
    //         show: false,
    //       },
    //       progress: {
    //         show: true,
    //         overlap: false,
    //         roundCap: true,
    //         clip: false,
    //         itemStyle: {
    //           borderWidth: 0,
    //           borderColor: "#464646",
    //         },
    //       },
    //       axisLine: {
    //         lineStyle: {
    //           width: 20,
    //         },
    //       },
    //       splitLine: {
    //         show: false,
    //         distance: 0,
    //         length: 10,
    //       },
    //       axisTick: {
    //         show: false,
    //       },
    //       axisLabel: {
    //         show: false,
    //         distance: 50,
    //       },
    //       data: gaugeData,
    //       detail: {
    //         width: "40%",
    //         height: "15%",
    //         fontSize: "18",
    //         color: "#fff",
    //         borderColor: "inherit",
    //         borderRadius: 20,
    //         borderWidth: 1,
    //         formatter: "{value}%",
    //       },
    //     },
    //   ],
    // };
    // myChart.setOption(option);
    // window.onresize = function() {
    //   myChart.resize();
    // };
  },
};
</script>
